"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookie = void 0;
const createNameRegExp = name => new RegExp(`(^| )${name}=([^;]+)`);
const getCookie = name => {
  const match = document.cookie.match(createNameRegExp(name));
  return (match ?? [])[2];
};
exports.getCookie = getCookie;
